import {postRequest} from "../routes/Routes";

export const loadUsers = async (values) => {
    let users = [];
    await postRequest(values).then(response => {
        if (response.status === 200) {
            users = response.data;
        } else {
            this.props.alert.error("An error occurred!");
        }
    });
    return users;
};

export const loadClients = async (values) => {
    let clients = [];
    await postRequest(values).then(response => {
        if (response.status === 200) {
            clients = response.data;
        } else {
            this.props.alert.error("An error occurred!");
        }
    });
    return clients;
};

export const loadFavoriteClients = async (values) => {
    let favoriteClients = [];
    await postRequest(values).then(response => {
        if (response.status === 200) {
            response.data.forEach((data) => {
                favoriteClients.push(data.client);
            });
        } else {
            this.props.alert.error("An error occurred!");
        }
    });
    return favoriteClients;
};

export const loadClientUsers = async (values) => {
    let clientUsers = [];
    await postRequest(values).then(response => {
        if (response.status === 200) {
            response.data.forEach((data) => {
                clientUsers.push(data.client);
            });
        } else {
            this.props.alert.error("An error occurred!");
        }
    });
    return clientUsers;
};

export const loadStatus = async (values) => {
    let statusList = [];
    await postRequest(values).then(response => {
        if (response.status === 200) {
            statusList = response.data;
        } else {
            this.props.alert.error("An error occurred!");
        }
    });
    return statusList;
};

export const loadFavoriteFiles = async (values) => {
    let favoriteFiles = [];
    await postRequest(values).then(response => {
        if (response.status === 200) {
            response.data.forEach((data) => {
                favoriteFiles.push(data.fileId);
            });
        } else {
            this.props.alert.error("An error occurred!");
        }
    });
    return favoriteFiles;
};
